var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 7C15.5 6.72385 15.7239 6.5 16 6.5H18C18.2761 6.5 18.5 6.72385 18.5 7V8H20C20.2761 8 20.5 8.22385 20.5 8.5V11.3H22V12.8H20.5V15.5C20.5 15.7761 20.2761 16 20 16H18.5V17C18.5 17.2761 18.2761 17.5 18 17.5H16C15.7239 17.5 15.5 17.2761 15.5 17V12.8H8.5V17C8.5 17.2761 8.27615 17.5 8 17.5H6C5.72385 17.5 5.5 17.2761 5.5 17V16H4C3.72386 16 3.5 15.7761 3.5 15.5V12.8H2V11.3H3.5V8.5C3.5 8.22385 3.72386 8 4 8H5.5V7C5.5 6.72385 5.72385 6.5 6 6.5H8C8.27615 6.5 8.5 6.72385 8.5 7V11.3H15.5V7Z",
    fill: "#444F60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExIco);
export default __webpack_public_path__ + "static/media/exIco.ae53619b0a102b23be78c4bae34e7d9b.svg";
export { ForwardRef as ReactComponent };